import React, { useEffect, useState, useRef } from 'react';
import './promo-card.scss';
import SharepointLink from '../../Global/SharepointLink/SharepointLink';
import { useLinkTypes } from '../../../hooks/useLinkTypes';
import CircularProgress from '@mui/material/CircularProgress';

function PromoCard(props) {
  const textAreaRef = useRef(null);
  let textElements = [];
  let mediaElements = [];
  const linkTypeQuery = useLinkTypes();

  if (props.heading) {
    textElements.push(
      <div className="card-heading" key="card-heading" style={{ color: props.textColor }}>
        {props.heading}
      </div>
    );
  }
  if (props.subheading) {
    textElements.push(
      <div
        className="card-subheading"
        key="card-subheading"
        style={{ color: props.subTextColor ? props.subTextColor : props.textColor }}
      >
        {props.subheading}
      </div>
    );
  }
  if (props.description) {
    textElements.push(
      <div
        className="card-description"
        key="card-description"
        style={{ color: props.subTextColor ? props.subTextColor : props.textColor }}
      >
        {props.description}
      </div>
    );
  }
  if (props.media) {
    mediaElements.push(
      <div className="card-media" key="card-media">
        <img src={props.media} />
      </div>
    );
  }
  if (props.media2) {
    mediaElements.push(
      <div className="card-media" key="card-media">
        <img src={props.media2} />
      </div>
    );
  }

  if (linkTypeQuery.isLoading) return <CircularProgress size="1em" />;

  const cardClass =
    'promo-card image-' +
    props.imageLocation +
    (props.textLocation ? ' text-' + props.textLocation : '');
  const cardContent = (
    <>
      {textElements.length > 0 ? <div className="card-text">{textElements}</div> : ''}
      {mediaElements}
    </>
  );

  return (
    <div
      className="promo-card-wrapper"
      style={
        props.linkType === linkTypeQuery.LINKTYPE.NOTHING
          ? { backgroundColor: props.backgroundColor, pointerEvents: 'none' }
          : { backgroundColor: props.backgroundColor }
      }
    >
      {props.link ? (
        <SharepointLink
          link={props.link}
          linkType={props.linkType}
          target="_blank"
          className={cardClass}
          baseUrl={`${process.env.REACT_APP_AGENTPORTAL_PREFIX}/Promos`}
        >
          {cardContent}
        </SharepointLink>
      ) : (
        <div className={cardClass}>{cardContent}</div>
      )}
    </div>
  );
}

export { PromoCard };
